import { render } from "./payAddonsServices.vue?vue&type=template&id=327df6ba"
import script from "./payAddonsServices.vue?vue&type=script&lang=js"
export * from "./payAddonsServices.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__